import { useCallback, useEffect } from "react"
import { useSearchParams, useParams } from 'react-router-dom'
import Cookies from 'js-cookie'

export const useBrandId = (defaultBrandId?: string) => { 
  const [searchParams, setSearchParams] = useSearchParams()
  const brandId = searchParams.get('brandId')
  const cookieBrandId = Cookies.get('current_brand') as string | undefined
  // keep the two in sync
  useEffect(() => {
    if (brandId && brandId !== cookieBrandId) {
      Cookies.set('current_brand', brandId)
      return
    }
    if (cookieBrandId && brandId !== cookieBrandId) {
      setSearchParams((prev) => ({ ...prev, brandId: cookieBrandId }))
      return
    }
    if (!brandId && !cookieBrandId && defaultBrandId) {
      Cookies.set('current_brand', defaultBrandId)
      setSearchParams((prev) => ({ ...prev, brandId: defaultBrandId }))
    }
  }, [brandId, cookieBrandId, defaultBrandId])

  const setBrandId = useCallback((newBrandId: string) => {
    setSearchParams((prev) => ({ ...prev, brandId: newBrandId }))
    Cookies.set('current_brand', newBrandId)
  }, [searchParams])

  return [brandId, setBrandId] as const
}

export const useCampaignId = (): string | undefined => {
  const { campaignId } = useParams()
  return campaignId
}